export var translates: any = {}
translates.FA = {
    Notpayed: 'پرداخت نشده',
    PaymentInProgress: 'در حال بررسی',
    PaymentComplete: 'پرداخت شده',
    ECB: 'بازاریاب',
    Vendor: 'فروشگاه',
    NotProcessed: 'پردازش نشده',
    Waiting: 'در حال انتظار',
    Approved: 'تایید شده',
    PackAndShipping: 'بسته‌بندی شده و آماده به ارسال',
    Returned: 'عودت داده شد',
    Delivered: 'تحویل داده شد',
    Canceled: 'لغو شد',
    Coupon_NotFound: 'کوپن یافت نشد',
    Coupon_Cant_Used_Anymore: ' تعداد مجاز استفاده از کوپن به اتمام رسیده',
    Coupon_Not_Active: 'کوپن فعال نیست',
    Coupon_Expired: 'تاریخ استفاده از کوپن گذشته است',
    Coupon_Cant_Used_AtThisTime: 'فعلا نمی توانید از این کوپن استفاده کنید',
    UploadedSalableItem: 'تعداد فیلد بارگزاری شده',
    RightSalableItem: 'تعداد فیلد صحیح',
    WrongSalableItem: 'تعداد فیلد اشتباه',
    ChangePriceCount: 'تعداد تغییرات قیمت  ',
    ChangeQuantityCount: 'تعداد تغییرات موجودی',
    justAvailableProduct: 'موجود',
    justUsedProduct: 'کارکرده',
    ProductName: 'نام محصول',
    Meta_MinPrice: 'قیمت',
    Meta_DatePublish: 'تاریخ انتشار',
    Meta_DateModifed: 'تاریخ به‌روزرسانی',
    Meta_UserViews: 'تعداد بازدید',
    Meta_SaleCount: 'تعداد فروش',
    Meta_CommentCount: 'تعداد نظرات',
    Meta_UserRating: 'محبوبیت کالا',
    MaxSaleCount: 'تعداد فروش',
    Meta_DateModified: 'تاریخ به روزرسانی قیمت',
    bestSeller: 'بهترین فروشنده',
    MinPrice: 'قیمت',
    MaxWarrantyRank: 'گارانتی',
    MinTransportDelay: 'زمان ارسال',
    MinTransportPrice: 'هزینه حمل',
    desc: 'نزولی',
    asc: 'صعودی',
    vPos: 'پرداخت آنلاین',
    COD: 'دریافت وجه هنگام تحویل کالا',
    Cart: 'پرداخت از طریق کارت به کارت',
    BankTransfer: 'انتقال وجه از طریق حواله‌ی بانکی',
    Keramat: 'خرید قسطی کرامت کارت',
    Hekmat: 'خرید قسطی حکمت کارت',
    MellatInsurance: 'خرید قسطی کارت بیمه ملت',
    Mellat: 'پرداخت آنلاین درگاه ملت',
    SamanKish: 'پرداخت آنلاین درگاه سامان کیش',
    Free_Advertisement: "آگهی رایگان",
    Coupon: "کوپن",
    Normal: "عادی"
};




// WEBPACK FOOTER //
// ./src/store-modules/app/value/translates.ts